import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import messages from "../../../assets/locale/messages";
import Modal from "../../../components/Modal";
import { DeleteModalIcon } from "../../../utils/Icons";
import { deleteSubCategoryRequest } from "../../../store/SubCategories/actions";

const DeleteSubCategory = ({ open, closeModal, subCategoryInfo }) => {
  const lang = useSelector((state) => state.locale.lang);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { subCategories, shared } = messages[lang];

  const handleConfirmDelete = () => {
    dispatch(
      deleteSubCategoryRequest({
        data: {
          Id: subCategoryInfo.id
        },
        src: subCategoryInfo.src,
        params: subCategoryInfo.params,
        navigate
      })
    );
    closeModal();
  };

  const deleteSubCategoryContent = () => {
    return (
      <div className="delete-product-container container d-flex flex-column justify-content-center align-items-center">
        <DeleteModalIcon />
        <div className="delete-product-content mt-2 d-flex flex-column justify-content-center align-items-center text-center">
          <Typography className="fsize-18 fweight-700">
            {`${subCategories.deleteSubCategory.content} "${subCategoryInfo.name}"`}
          </Typography>
          <Typography className="text-secondary fsize-14 mt-2 fweight-400">
            {subCategories.deleteSubCategory.confirmationContent}
          </Typography>
          <Typography className="text-secondary fsize-14 mt-2 fweight-400">
            {subCategories.deleteSubCategory.subConfirmationContent}
          </Typography>
        </div>
      </div>
    );
  };

  return (
    <Modal
      open={open}
      handleConfirm={() => {
        handleConfirmDelete();
      }}
      handleClose={closeModal}
      isContentText={false}
      content={deleteSubCategoryContent()}
      hasActions={true}
      confirmBtnTxt={shared.delete}
      cancelBtnTxt={shared.cancel}
      handleCancel={closeModal}
      showCloseIcon
      title
      confirmBtnClass="danger-btn border-radius-12 ps-5 pe-5"
      cancelBtnClass="text-secondary border-radius-12 ps-5 pe-5"
      maxWidth={"xs"}
    />
  );
};

export default DeleteSubCategory;

DeleteSubCategory.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  subCategoryInfo: PropTypes.object.isRequired
};
